"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_78_4_0 = void 0;
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const applyKetteSerieType = (kette) => {
    // there is a kette-serietype set and its not the default one?
    // .. AND there is no IproProduktgruppenId to detect which kette it is?
    // => keep it! happens to espool-twisterbands somehow..
    if (Boolean(kette.KetteSerieType) && kette.KetteSerieType !== echain_shared_articles_1.KetteSerieType.default && !kette.IproProduktgruppenId) {
        return;
    }
    kette.KetteSerieType = echain_shared_articles_1.KetteSerieType.default;
    if (!kette.IproProduktgruppenId)
        return;
    // twisterband
    if (echain_shared_articles_1.TwisterbandIproProduktgruppenIds[kette.IproProduktgruppenId]) {
        kette.KetteSerieType = echain_shared_articles_1.KetteSerieType.twisterband;
        if (kette.ArticleSpecs) {
            kette.ArticleSpecs = kette.ArticleSpecs.filter((aSpecs) => aSpecs !== 'twisterband');
        }
    }
    // twisterchain
    if (echain_shared_articles_1.TwisterchainIproProduktgruppenIds[kette.IproProduktgruppenId]) {
        kette.KetteSerieType = echain_shared_articles_1.KetteSerieType.twisterchain;
        if (kette.ArticleSpecs) {
            kette.ArticleSpecs = kette.ArticleSpecs.filter((aSpecs) => aSpecs !== 'twisterchain');
        }
    }
    // triflexR
    if (echain_shared_articles_1.TriflexRIproProduktgruppenIds[kette.IproProduktgruppenId]) {
        kette.KetteSerieType = echain_shared_articles_1.KetteSerieType.triflexR;
        if (kette.ArticleSpecs) {
            kette.ArticleSpecs = kette.ArticleSpecs.filter((aSpecs) => aSpecs !== 'triflexR');
        }
    }
    // rxRohr
    if (echain_shared_articles_1.RXIproProduktgruppenIds[kette.IproProduktgruppenId]) {
        kette.KetteSerieType = echain_shared_articles_1.KetteSerieType.rxRohr;
        if (kette.ArticleSpecs) {
            kette.ArticleSpecs = kette.ArticleSpecs.filter((aSpecs) => aSpecs !== 'rxRohr');
        }
    }
    // eskin
    if (echain_shared_articles_1.ESkinIproProduktgruppenIds[kette.IproProduktgruppenId]) {
        kette.KetteSerieType = echain_shared_articles_1.KetteSerieType.eskin;
        if (kette.ArticleSpecs) {
            kette.ArticleSpecs = kette.ArticleSpecs.filter((aSpecs) => aSpecs !== 'eskin');
        }
    }
};
/**
 * Migrate to 78.4.0
 *
 * Adds proper ArticleSpecs for special ketten (also handles espool child ketten)
 */
const migration_78_4_0 = (json) => {
    var _a;
    if (json === null || json === void 0 ? void 0 : json.Kette)
        applyKetteSerieType(json.Kette);
    if (json === null || json === void 0 ? void 0 : json.Espool) {
        (_a = json.Children) === null || _a === void 0 ? void 0 : _a.forEach((childConfig) => {
            if (childConfig === null || childConfig === void 0 ? void 0 : childConfig.Kette)
                applyKetteSerieType(childConfig.Kette);
        });
    }
    return json;
};
exports.migration_78_4_0 = migration_78_4_0;
//# sourceMappingURL=migration_78_4_0.js.map